import { useState } from "react";
import { motion, useScroll, useTransform, useSpring, useMotionValueEvent } from "framer-motion";

const CHECKPOINTS = [
  { id: "top", at: 0.02 },
  { id: "manifesto", at: 0.22 },
  { id: "reach", at: 0.42 },
  { id: "launchpad", at: 0.58 },
  { id: "trailer", at: 0.74 },
  { id: "contact", at: 0.9 },
];

export default function ScrollRocket() {
  const { scrollYProgress } = useScroll();
  const smooth = useSpring(scrollYProgress, { stiffness: 60, damping: 18 });
  const y = useTransform(smooth, [0, 1], ["10vh", "80vh"]);
  const tilt = useTransform(smooth, [0, 0.5, 1], [-4, 3, -4]);
  const [passed, setPassed] = useState(0);

  useMotionValueEvent(scrollYProgress, "change", (v) => {
    const n = CHECKPOINTS.filter((c) => v >= c.at).length;
    if (n !== passed) setPassed(n);
  });

  return (
    <div
      className="fixed right-5 top-0 bottom-0 z-40 hidden lg:block pointer-events-none"
      data-testid="scroll-rocket-journey"
      aria-hidden
    >
      <div className="absolute right-[22px] top-[10vh] bottom-[18vh] w-px bg-white/10" />
      {CHECKPOINTS.map((c, i) => (
        <span
          key={c.id}
          data-testid={`checkpoint-${c.id}`}
          className={`absolute right-[19px] w-[7px] h-[7px] rounded-full transition-all duration-500 ${
            i < passed
              ? "bg-signal shadow-[0_0_10px_rgba(63,169,245,0.9)]"
              : "bg-white/20"
          }`}
          style={{ top: `calc(${10 + c.at * 70}vh)` }}
        />
      ))}
      <motion.img
        src="/logo-symbol.webp"
        alt=""
        style={{ y, rotate: tilt }}
        className="absolute right-0 w-11 h-auto drop-shadow-[0_0_18px_rgba(63,169,245,0.45)]"
        data-testid="scroll-rocket"
      />
    </div>
  );
}
